import React from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";

/**
 * Full-page notice shown when the API is temporarily unavailable on page load
 * and there is no usable session token to fall back on. The user stays signed
 * in to Firebase; "Try again" reloads once the API is back.
 */
const Representation = ({ onRetry = () => window.location.reload() }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container} role="alert">
      <div className={styles.card}>
        <h1 className={styles.title}>
          {t("service_unavailable.title", "Service temporarily unavailable")}
        </h1>
        <p className={styles.body}>
          {t(
            "service_unavailable.description",
            "We're having trouble reaching Pivony right now. You're still signed in. Please try again in a few moments."
          )}
        </p>
        <Button type="primary" size="large" onClick={onRetry}>
          {t("service_unavailable.retry", "Try again")}
        </Button>
      </div>
    </div>
  );
};

export default Representation;
